
// @ts-ignore
import {getConfig, getLanguageConfig} from "../../utils/config-helper";
// @ts-ignore
import {translate} from '@elements/translations';
import {ref, computed, reactive, onMounted, defineComponent} from 'vue';
// @ts-ignore
import Popper from 'vue3-popper/dist/popper.esm';
export default defineComponent({
    name: "PriceLegendActivities",
    components: {
        Popper
    },
    props: {
    },
    setup(props) {
        const priceTendencies = computed(() => {
            return getConfig('priceTendencyLegendActivities');
        });

        return {
            priceTendencies,
            translate
        }
    }
})
